import React from "react"
import Layout from "../containers/Layout";
import { graphql } from "gatsby"
import { useTranslation } from "react-i18next"
import SEO from "../components/genericComponents/SEO";

const PolicyCookiesPage = props => {
  const { t } = useTranslation()
  const renderI18nHtml = key => (
    <span dangerouslySetInnerHTML={{ __html: t(key) }} />
  )

  return (
    <Layout
      navBarProps={{
        navClass: "is--white",
      }}
      logoClassName={"filterClass"}
      path={props.path}
      optionsBooking={{ path: props.path }}
    >
       <SEO
        title={t('seo_policity_cookies_title')}
        desc={t('seo_policity_cookies_description')}
        pathname={"/politica-cookies/"}
        article={false}
      />
      <section className="terms-content container-generic" data-scroll-section>
        <h1>{t("cookies_policy_title")}</h1>
        <h3>{t("cookies_policy_intro_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_intro_content")}</p>

        <h3>{t("cookies_policy_affected_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_affected_content")}</p>

        <h3>{t("cookies_policy_types_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_types_content_a")}</p>
        <p>{renderI18nHtml("cookies_policy_types_content_b")}</p>
        <p>{renderI18nHtml("cookies_policy_types_content_c")}</p>
        <ul>
          <li>{renderI18nHtml("cookies_policy_types_item1")}</li>
          <li>{renderI18nHtml("cookies_policy_types_item2")}</li>
          <li>{renderI18nHtml("cookies_policy_types_item3")}</li>
          <li>{renderI18nHtml("cookies_policy_types_item4")}</li>
          <li>{renderI18nHtml("cookies_policy_types_item5")}</li>
        </ul>

        <h3>{t("cookies_policy_used_title")}</h3>
        <div className="terms-content__cookies-table-wrap">
          <table className="terms-content__cookies-table">
            <thead>
              <tr>
                <th>{t("cookies_policy_table_col_name")}</th>
                <th>{t("cookies_policy_table_col_purpose")}</th>
                <th>{t("cookies_policy_table_col_expiry")}</th>
                <th>{t("cookies_policy_table_col_provider")}</th>
              </tr>
            </thead>
            <tbody>
              {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(row => (
                <tr key={`cookie-row-${row}`}>
                  <td>{t(`cookies_policy_table_row${row}_name`)}</td>
                  <td>{t(`cookies_policy_table_row${row}_purpose`)}</td>
                  <td>{t(`cookies_policy_table_row${row}_expiry`)}</td>
                  <td>{t(`cookies_policy_table_row${row}_provider`)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <h3>{t("cookies_policy_revocation_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_revocation_content")}</p>
        <ul>
          <li>{renderI18nHtml("cookies_policy_revocation_browser1")}</li>
          <li>{renderI18nHtml("cookies_policy_revocation_browser2")}</li>
          <li>{renderI18nHtml("cookies_policy_revocation_browser3")}</li>
          <li>{renderI18nHtml("cookies_policy_revocation_browser4")}</li>
          <li>{renderI18nHtml("cookies_policy_revocation_browser5")}</li>
        </ul>
        <p>{renderI18nHtml("cookies_policy_revocation_note")}</p>

        <h3>{t("cookies_policy_changes_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_changes_content")}</p>

        <h3>{t("cookies_policy_disable_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_disable_content1")}</p>
        <p>{renderI18nHtml("cookies_policy_disable_content2")}</p>
        <p>{renderI18nHtml("cookies_policy_disable_content3")}</p>
        <p>{renderI18nHtml("cookies_policy_disable_content4")}</p>
        <p>{renderI18nHtml("cookies_policy_disable_content5")}</p>

        <h3>{t("cookies_policy_rgpd_title")}</h3>
        <p>{renderI18nHtml("cookies_policy_rgpd_q1")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a1")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_q2")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a2")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_q3")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a3")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_q4")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a4")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_q5")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a5")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_q6")}</p>
        <p>{renderI18nHtml("cookies_policy_rgpd_a6")}</p>

      </section>
    </Layout>
  )
}

export default PolicyCookiesPage
export const query = graphql`
  query ($language: String!) {
    locales: allLocale(filter: { language: { eq: $language } }) {
      edges {
        node {
          ns
          data
          language
        }
      }
    }
  }
`
